import { stringToDate } from '../../utils/dates';
import { PortfolioReportParam } from '../../api/usePortfolioReportParamsQuery';
import { DateRange } from '../../../CommonComponents/OPL/dates/DateRangePicker/useDateRangePicker';

interface UseDateRangePickerWithPresetsParams {
  param: PortfolioReportParam;
}

export const useDateRangePickerWithPresets = ({ param }: UseDateRangePickerWithPresetsParams) => {
  const { inceptionDate, customPeriodEnabled, periodOptions, range } = param;

  const rangePresets: DateRange[] = (periodOptions || []).map(({ label, range: periodRange }) => ({
    label,
    dates: [stringToDate(periodRange.startDate), stringToDate(periodRange.endDate)],
  }));

  const minDate = inceptionDate ? stringToDate(inceptionDate) : undefined;

  return {
    range: range!, // Since we default range to YTD, it will never be undefined
    rangePresets,
    minDate,
    customPeriodEnabled: !!customPeriodEnabled,
  };
};
